{
  "version": 1,
  "asset_id": "ebde51c2-9c16-44e0-a4fd-38738d3d58f0",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/ebde51c2-9c16-44e0-a4fd-38738d3d58f0/southend-drone-poster-960.webp",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/ebde51c2-9c16-44e0-a4fd-38738d3d58f0/southend-drone-poster-960.webp",
  "original_filename": "southend-drone-poster-960.webp",
  "size": 89112,
  "content_type": "image/webp",
  "created_at": "2026-07-22T22:52:31Z"
}
